export default function Testimonials() {
  const testimonials = [
    {
      name: 'Maria Silva',
      role: 'Proprietária - Confeitaria Doce Sabor',
      image: 'https://public.readdy.ai/ai/img_res/2c9f09002480e044cc8eefeb172f88f4.jpg',
      text: 'O LBAs Essentials transformou completamente minha confeitaria. Em 8 meses consegui organizar todos os processos, reduzir desperdícios em 35% e aumentar a produção sem contratar mais pessoas. O investimento se pagou rapidamente!',
      rating: 5
    },
    {
      name: 'Carlos Mendes',
      role: 'Fundador - Tech Solutions MEI',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20technology%20entrepreneur%20working%20on%20laptop%20in%20modern%20office%2C%20confident%20smile%2C%20realistic%20portrait%20photography%2C%20business%20casual%20attire%2C%20successful%20tech%20startup%20atmosphere&width=400&height=400&seq=test-002&orientation=squarish',
      text: 'Como MEI de tecnologia, eu estava perdido em meio a tantos projetos. O programa me ajudou a estruturar processos, priorizar clientes e ganhar 40% mais tempo para focar no que realmente importa. Recomendo muito!',
      rating: 5
    },
    {
      name: 'Ana Paula Costa',
      role: 'Diretora - Estúdio Beleza & Estilo',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20beauty%20salon%20owner%20in%20elegant%20modern%20beauty%20studio%2C%20confident%20professional%20portrait%2C%20realistic%20photography%2C%20sophisticated%20business%20atmosphere%2C%20natural%20lighting&width=400&height=400&seq=test-003&orientation=squarish',
      text: 'Meu salão estava crescendo mas a operação era caótica. Com o LBAs Essentials consegui mapear tudo, treinar a equipe e criar processos que funcionam. Hoje atendo 50% mais clientes com a mesma equipe e muito menos estresse.',
      rating: 5
    },
    {
      name: 'Roberto Almeida',
      role: 'Proprietário - Distribuidora RA',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20warehouse%20distribution%20business%20owner%20in%20modern%20logistics%20facility%2C%20confident%20portrait%2C%20realistic%20photography%2C%20professional%20business%20attire%2C%20successful%20entrepreneur&width=400&height=400&seq=test-004&orientation=squarish',
      text: 'A consultoria foi essencial para organizar minha distribuidora. Reduzi custos operacionais, melhorei o controle de estoque e aumentei a satisfação dos clientes. O acompanhamento mensal fez toda diferença nos resultados.',
      rating: 5
    },
    {
      name: 'Juliana Ferreira',
      role: 'CEO - Marketing Digital JF',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20digital%20marketing%20agency%20owner%20in%20creative%20modern%20office%2C%20confident%20smile%2C%20realistic%20portrait%20photography%2C%20creative%20professional%20atmosphere%2C%20bright%20workspace&width=400&height=400&seq=test-005&orientation=squarish',
      text: 'Estava com dificuldade para escalar minha agência. O programa me deu clareza sobre processos, automações e gestão de equipe. Em 10 meses dobrei o faturamento mantendo a qualidade. Melhor investimento que fiz!',
      rating: 5
    },
    {
      name: 'Pedro Santos',
      role: 'Fundador - Oficina Mecânica PS',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20automotive%20mechanic%20shop%20owner%20in%20clean%20modern%20garage%20workshop%2C%20confident%20professional%20portrait%2C%20realistic%20photography%2C%20successful%20business%20atmosphere%2C%20organized%20workspace&width=400&height=400&seq=test-006&orientation=squarish',
      text: 'Minha oficina funcionava mas sem organização. Com o LBAs aprendi a documentar processos, treinar mecânicos e controlar melhor os custos. Resultado: mais lucro, menos retrabalho e clientes mais satisfeitos.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            O que nossos clientes dizem
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Histórias reais de MEIs e pequenas empresas que transformaram 
            seus negócios com o LBAs Essentials
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-coral-500 text-xl"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover object-top"
                />
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-coral-500 mb-2">150+</div>
            <div className="text-gray-600">Empresas atendidas</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-coral-500 mb-2">98%</div>
            <div className="text-gray-600">Satisfação</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-coral-500 mb-2">+40%</div>
            <div className="text-gray-600">Produtividade média</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-coral-500 mb-2">12</div>
            <div className="text-gray-600">Anos de experiência</div>
          </div>
        </div>
      </div>
    </section>
  );
}
